<section class="bg-second-level rounded-md p-4 flex flex-col">
  <div class="mb-3 flex items-start justify-between gap-3">
    <div class="flex flex-col">
      <h4 class="text-base font-semibold">{{ titleKey() | transloco: titleParams() }}</h4>
      @if (subtitleKey()) {
        <span class="text-muted-color text-sm">{{ subtitleKey() | transloco }}</span>
      }
    </div>
    <ng-content select="[sectionAction]" />
  </div>
  <ng-content />
</section>
